/* eslint-disable no-shadow */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import WidgetLoading from "../shared/loaders/WidgetLoading";
import employerTimeToHireMetricsType from "./types/employerTimeToHireMetricsType";
import {
  Wrapper,
  Header,
  Body,
  Row,
  Column,
  Number,
  Description,
  InfoDot,
} from "./styles/employer-time-to-hire-metrics-styles";
import { isFeatureEnabled } from "../../helpers";

export const EmployerTimeToHireMetrics = ({ loading, employerMetrics }) => {
  const hiringHubTimeToHire = isFeatureEnabled("demoEnvironment")
    ? 21
    : employerMetrics?.timeToHire?.hhAvgTimeToHire;

  return (
    <Wrapper data-test-id="employer-time-to-hire-metrics">
      {loading && <WidgetLoading />}
      <Header className="panel-heading">
        <div className="panel-title" data-test-id="tth-metrics-title">
          {employerMetrics &&
            employerMetrics.isPortalEmployer &&
            "Marketplace "}
          Time To Hire
        </div>
      </Header>
      <Body>
        <Row>
          <Column flex={1} data-test-id="employer-atth">
            <ReactTooltip
              html
              place="bottom"
              type="dark"
              effect="float"
              aria-haspopup="true"
              id="info-tooltip"
            />
            <Number
              fontSize="medium"
              data-tip="The elapsed time between job posting and job offer accepted"
              data-for="info-tooltip"
            >
              {employerMetrics &&
                `${employerMetrics.timeToHire.yourAvgTimeToHire} days`}
              <InfoDot>
                <FontAwesomeIcon icon={faInfoCircle} />
              </InfoDot>
            </Number>
            <Description>Your Avg. Time to Hire</Description>
          </Column>
          <Column flex={1} data-test-id="hh-atth">
            <ReactTooltip
              html
              place="bottom"
              type="dark"
              effect="float"
              aria-haspopup="true"
              id="info-tooltip-2"
            />
            <Number fontSize="medium">{hiringHubTimeToHire}</Number>
            <Description>HH Avg. Time to Hire</Description>
          </Column>
          <Column flex={1} data-test-id="industry-atth">
            <ReactTooltip
              html
              place="bottom"
              type="dark"
              effect="float"
              aria-haspopup="true"
              id="info-tooltip"
            />
            <Number
              fontSize="medium"
              data-tip="SHRM 2017"
              data-for="info-tooltip"
            >
              {employerMetrics &&
                employerMetrics.timeToHire.industryAvgTimeToHire}
              <InfoDot>
                <FontAwesomeIcon icon={faInfoCircle} />
              </InfoDot>
            </Number>
            <Description>Industry Avg. Time to Hire</Description>
          </Column>
        </Row>
      </Body>
    </Wrapper>
  );
};

EmployerTimeToHireMetrics.propTypes = {
  loading: PropTypes.bool.isRequired,
  employerMetrics: employerTimeToHireMetricsType,
};

EmployerTimeToHireMetrics.defaultProps = {
  employerMetrics: PropTypes.shape({
    timeToHire: PropTypes.shape({
      yourAvgTimeToHire: PropTypes.isNull,
      hhAvgTimeToHire: PropTypes.isNull,
      industryAvgTimeToHire: PropTypes.isNull,
    }),
  }),
};

const mapStateToProps = (state) => ({
  loading: state.dashboard.loading,
  employerMetrics: state.dashboard.employerMetrics,
});

export default connect(mapStateToProps, {})(EmployerTimeToHireMetrics);
